import React, { useContext } from 'react'
import { FileContext } from 'src/containers/Application/Files/Context'
import FilesMainKind from './FilesMainKind'
import { useStyles } from './Style'

const FilesList: React.FC = (): React.ReactElement => {
  const classes = useStyles()
  const {
    applicants: { current },
  } = useContext(FileContext)

  if (!current || !current.required_uploads) {
    return <></>
  }
  return (
    <div className={classes.container}>
      {current.required_uploads.map((required) => (
        <FilesMainKind key={required.kind} requiredFile={required} />
      ))}
    </div>
  )
}

export default FilesList
